export default __webpack_public_path__ + "static/media/dislike_btn.8874ef9b.svg";